import React, { useState, useContext, useEffect } from "react";
import "react-phone-input-2/lib/style.css";
import applelogo from "../../assets/images/apple-brands.svg";
import x from "../../assets/images/X.png";

import {
  signInWithGoogle,
  createUserDocumentFromAuth,
  createUserWithEmailAndPassword,
  auth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  rmPhone,
  checkUsername,
  checkEmail,
  checkPhone,
  signInAuthWithEmailAndPassword,
  signInWithApple,
  createUserDocumentFromApple,
} from "../../utils/firebase/firebase.utils";
import branch from "branch-sdk";

import { Modal } from "react-bootstrap";
import SignUp from "../SignUp/SignUp";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  IsGuest,
  SetJoinCoumminity,
  SetSignIn,
  SetSignUpp,
} from "../../features/Products/ProductSlice";

function SignIn({ signIn, handleSignIn, handleSignUp, handleForgetpassword }) {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [usernameReq, setUsernameReq] = useState(false);
  const [openModal, setModal] = useState(false);
  const [join, setJoin] = useState(false);
  const [eye, seteye] = useState(true);
  const [password, setpassword] = useState("");
  const [passwordReq, setPasswordReq] = useState(false);
  const [passwordVal, setpasswordVal] = useState(t("Required field"));
  const [showpassword, setShowpassword] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [isUsernameExist, setIsUsernameExist] = useState(false);
  const [show, setshow] = useState(true);
  const [showVerify, setshowVerify] = useState(false);
  const [logining, setLogining] = useState(false);
  const [type, settype] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [isProvider, setIsProvider] = useState(false);
  const dispatch = useDispatch();
  const { singin, singupp, joincommunity } = useSelector(
    (store) => store.allproducts
  );

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  useEffect(() => {
    dispatch(SetJoinCoumminity(false));
  }, []);
  const SignInWithGoogle = async () => {
    setIsProvider(true);
    //await SignInUser();
    const { user } = await signInWithGoogle();
    if (user.uid != "no_user") {
      if (user.displayName) {
        var username = user.displayName.toLowerCase().replace(/\s/g, "");
        var existUsername = await checkUsername(username);
        while (existUsername) {
          username = username + getRandomNumber(0, 1000);
          existUsername = await checkUsername(username);
        }
      } else {
        var username = user.email.split("@")[0].toLowerCase();
        var existUsername = await checkUsername(username);
        while (existUsername) {
          username = username + getRandomNumber(0, 1000);
          existUsername = await checkUsername(username);
        }
      }
      const serDocref = await createUserDocumentFromAuth(user, {
        username: username,
        phone: !user.phoneNumber ? "" : user.phoneNumber,
      });
      handleSignIn(false);
    }
  };
  const SignInWithApple = async () => {
    setIsProvider(true);
    const { user } = await signInWithApple();

    if (user.uid != "no_user") {
      // Generate username
      let username;
      if (user.displayName) {
        username = user.displayName.toLowerCase().replace(/\s/g, "");
      } else {
        username = user.email
          ? user.email.split("@")[0].toLowerCase()
          : `apple${Date.now()}`;
      }

      // Check for username availability
      let existUsername = await checkUsername(username);
      while (existUsername) {
        username = username + getRandomNumber(0, 1000);
        existUsername = await checkUsername(username);
      }

      // Get Apple user data from credential if available
      let appleUserData = null;
      if (
        user.providerData &&
        user.providerData.length > 0 &&
        user.providerData[0].providerId === "apple.com"
      ) {
        // Try to get the additional user data from the sign-in result
        // This would need to be passed from your signInWithApple function
        const additionalUserInfo = auth.currentUser
          .getIdTokenResult()
          .then((idTokenResult) => {
            if (
              idTokenResult.claims &&
              idTokenResult.claims.firebase &&
              idTokenResult.claims.firebase.sign_in_attributes
            ) {
              return idTokenResult.claims.firebase.sign_in_attributes;
            }
            return null;
          });

        if (additionalUserInfo && additionalUserInfo.user) {
          try {
            appleUserData = JSON.parse(additionalUserInfo.user);
          } catch (e) {
            console.error("Could not parse Apple user data", e);
          }
        }
      }

      const serDocref = await createUserDocumentFromApple(user, {
        username: username,
        phone: !user.phoneNumber ? "" : user.phoneNumber,
        appleUserData: appleUserData,
      });

      handleSignIn(false);
    }
  };
  const handleContinueAsGuest = () => {
    // Event tracking script
    window.gtag("config", "AW-11517267669");
    window.gtag("event", "GetStartedWithGuest", {
      event_category: "Engagement",
      event_label: "Guest",
      value: 1,
    });
  };

  const SignInUser = async () => {
    setLogining(true);
    try {
      if (isProvider) {
        const { user } = await signInWithGoogle();
        //const serDocref = await createUserDocumentFromAuth(user, {});
      } else {
        const user = await signInAuthWithEmailAndPassword(username, password);
        if (user) {
          setshow(false);
          setUsername("");
          setpassword("");
          setLogining(false);
          handleSignIn(false);
        } else {
          setWrongPassword(true);
          if (i18n.language == "en") {
            setpasswordVal("Wrong Username or Password");
          } else {
            setpasswordVal("اسم المستخدم خاطئ أو كلمة المرور خاطئة");
          }
          setLogining(false);
        }
      }
      //console.log(user);
    } catch (error) {
      if (error.code == "auth/wrong-password") {
        setWrongPassword(true);
        if (i18n.language == "en") {
          setpasswordVal("Wrong Username or Password");
        } else {
          setpasswordVal("اسم المستخدم خاطئ أو كلمة المرور خاطئة");
        }
        setLogining(false);
      }
    }
  };

  //   const SignInUser = async () => {
  //     const existUsername = await checkUsername(username);
  //     if (!existUsername) {
  //       if (isProvider) {
  //         const { user } = await signInWithGoogle();
  //         const serDocref = await createUserDocumentFromAuth(user);
  //       } else {
  //         if (password < 6) return;
  //         try {
  //           const { user } = await createUserWithEmailAndPassword(
  //             auth,
  //             email,
  //             password
  //           );
  //           setUsername(username.toLowerCase());
  //           const serDocref = await createUserDocumentFromAuth(user, {
  //             username,
  //             firstName,
  //             lastName,
  //             phone:'+'+phoneNumber,
  //           });
  //         } catch (error) {
  //           if (error.code === "auth/email-already-in-use") {
  //             alert("Cann't create user, email already used");
  //           }
  //           console.log(error);
  //         }
  //       }
  //     } else {
  //       setIsUsernameExist(existUsername);
  //     }
  //   };

  const Eye = () => {
    seteye(showpassword);
    settype(!showpassword);
    setShowpassword(!showpassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleHover = () => {
    //console.log('hiiii');
    if (!username) {
      setUsernameReq(true);
    } else {
      setUsernameReq(false);
    }
    if (!password) {
      setPasswordReq(true);
      if (i18n.language == "en") {
        setpasswordVal("*Required field");
      } else {
        setpasswordVal("*يجب إملاء هذا الحقل");
      }
    } else {
      if (password.length < 6) {
        setPasswordReq(true);
        if (i18n.language == "en") {
          setpasswordVal("Too short");
        } else {
          setpasswordVal("قصير جدًا");
        }
      } else {
        setPasswordReq(false);
      }
    }
  };
  return (
    <>
      <Modal
        show={signIn}
        // onHide={() => {
        //   handleSignIn(false);
        //   localStorage.removeItem("signupEmail");
        //   localStorage.removeItem("resendTimer");
        // }}
        className="modal fade signwidth custom-modal-width montserrat-font"
        centered
      >
        <Modal.Body className="p-0 m-0 montserrat-font">
          <div className="border-none">
            <div className="row mx-0">
              {/* Left image column with enhanced animation */}
              <div
                className="col-6 px-0 d-none d-lg-block"
                style={{ overflow: "hidden" }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    borderTopLeftRadius: "10px",
                    borderBottomLeftRadius: "10px",
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    transition: "all 0.4s ease-in-out",
                  }}
                >
                  <img
                    alt="main"
                    src="/modalbgimage.webp"
                    className="w-100"
                    style={{
                      transition: "all 0.4s ease-in-out",
                      transform: singin ? "scale(1.02)" : "scale(1)",
                      objectFit: "cover",
                      height: "100%",
                      borderTopLeftRadius: "10px",
                      borderBottomLeftRadius: "10px",
                    }}
                  />
                </div>
              </div>

              {/* Right content column with fade transition */}
              <div
                className="col-lg-6 col-12 px-0"
                style={{
                  position: "relative",
                }}
              >
                <div className="px-lg-3 pt-3 montserrat-font">
                  <img
                    onClick={() => {
                      handleSignIn(false);
                      localStorage.removeItem("signupEmail");
                      localStorage.removeItem("resendTimer");
                    }}
                    src={x}
                    alt="main"
                    style={{
                      position: "absolute",
                      right: "13px",
                      height: "10px",
                      width: "10px",
                      cursor: "pointer",
                    }}
                  />
                  {!joincommunity ? (
                    // Improved tabs with fixed dimensions and transitions
                    <div className="d-flex px-2" style={{ height: "40px" }}>
                      <div
                        className={`togglebbtn fw-normal w-50 text-center  ${
                          singupp ? `togglesign` : `toggleunsign`
                        }`}
                        onClick={() => {
                          dispatch(SetSignUpp(true));
                          dispatch(SetSignIn(false));
                        }}
                        style={{
                          fontSize: "16px",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        {t("Sign upmodal")}
                      </div>
                      <div
                        className={`togglebbtn fw-normal w-50 text-center  ${
                          singin ? `togglesign` : `toggleunsign`
                        }`}
                        onClick={() => {
                          dispatch(SetSignIn(true));
                          dispatch(SetSignUpp(false));
                        }}
                        style={{
                          fontSize: "16px",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        {t("Sign in")}
                      </div>
                    </div>
                  ) : null}

                  {/* Form content with fade transitions */}
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    {singin && (
                      <div
                        style={{
                          minHeight: "400px",
                          height: "auto",
                          width: "100%",
                          opacity: singin ? 1 : 0,
                          transition: "opacity 0.4s ease-in-out",
                          visibility: singin ? "visible" : "hidden",
                        }}
                      >
                        <form
                          className="px-md-2 px-3 pt-md-5 pt-3"
                          onSubmit={handleSubmit}
                        >
                          <div className="row mx-0">
                            <div className="col-12 px-0">
                              <div className="mb-1">
                                <label
                                  htmlFor="username"
                                  className="form-label mb-0 "
                                  style={{
                                    fontSize: "13px",
                                    color: "#262626",
                                    fontWeight: "400",
                                  }}
                                >
                                  {t("Username")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control formlogin2 mt-1"
                                  id="username"
                                  value={username}
                                  placeholder={t("Username")}
                                  name="username"
                                  onChange={(e) => setUsername(e.target.value)}
                                  aria-describedby="emailHelp"
                                />
                                <div
                                  id="emailHelp"
                                  className="error-text"
                                  style={{
                                    color: isUsernameExist
                                      ? "red"
                                      : usernameReq
                                      ? "red"
                                      : "gray",
                                    fontSize: "11px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {isUsernameExist
                                    ? t("Already exists")
                                    : t("Required field")}
                                </div>
                              </div>
                              <div className="mb-1 pt-md-3 ">
                                <label
                                  htmlFor="password"
                                  className="form-label mb-0 "
                                  style={{
                                    fontSize: "13px",
                                    color: "#262626",
                                    fontWeight: "400",
                                  }}
                                >
                                  {t("Password")}
                                </label>
                                <div className="input-group">
                                  <input
                                    type={eye ? "password" : "text"}
                                    required
                                    className={` form-control mt-1 ${
                                      i18n.language == "en"
                                        ? "formloginshow"
                                        : "formloginshowAr"
                                    }`}
                                    name="password"
                                    placeholder={t("Password")}
                                    value={password}
                                    onChange={(e) =>
                                      setpassword(e.target.value)
                                    }
                                  />
                                  <span
                                    style={{
                                      borderRadius: "0px",
                                    }}
                                    className={` 
                                      mt-1
                          ${
                            i18n.language == "en"
                              ? "faform-loginshow"
                              : "faform-loginshowAr"
                          } fa input-group-text ${eye ? t("Show") : t("Hide")}`}
                                  >
                                    <div
                                      onClick={Eye}
                                      className={`fa ${
                                        eye ? t("Show") : t("Hide")
                                      }`}
                                    >
                                      {eye ? t("Show") : t("Hide")}
                                    </div>
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div
                                    id="emailHelp"
                                    className="error-text"
                                    style={{
                                      color: passwordReq
                                        ? "red"
                                        : wrongPassword
                                        ? "red"
                                        : "gray",
                                    }}
                                  >
                                    {passwordVal}
                                  </div>
                                  <div
                                    className="forgetpass"
                                    onClick={() =>
                                      handleSignIn(false) &
                                      handleForgetpassword(true)
                                    }
                                  >
                                    {t("Forgot Password")}
                                  </div>
                                </div>
                                <div
                                  className=" pt-4"
                                  onMouseEnter={handleHover}
                                >
                                  <button
                                    type="submit"
                                    id="submit"
                                    className="btn-login w-100"
                                    disabled={
                                      !username ||
                                      !password ||
                                      username.length < 4 ||
                                      password.length < 6
                                    }
                                    onClick={
                                      logining
                                        ? () => {}
                                        : () =>
                                            SignInUser() &
                                            branch.track(
                                              "LoginWithEmailAndPassword"
                                            )
                                    }
                                    style={{
                                      display: !showVerify ? "block" : "none",
                                    }}
                                  >
                                    {logining ? t("LOGIN2") : t("Log in")}
                                  </button>
                                </div>

                                {/* Or */}
                                <div
                                  className={`mt-2 d-flex align-items-center justify-content-center ${
                                    !showVerify
                                      ? `pt-md-2 pb-md-2`
                                      : `pt-md-0 pb-md-1`
                                  } p-0 text-center pt-2 pb-2`}
                                  style={{
                                    color: "#808080",
                                  }}
                                >
                                  <hr
                                    className="flex-grow-1  "
                                    style={{
                                      border: "1px solid #9A9A9A",
                                    }}
                                  />
                                  <span
                                    className="mx-2"
                                    style={{
                                      fontSize: "14px",
                                    }}
                                  >
                                    {t("or")}
                                  </span>
                                  <hr
                                    className="flex-grow-1  "
                                    style={{
                                      border: "1px solid #9A9A9A",
                                    }}
                                  />
                                </div>
                                {/* sign in with google */}
                                <div className="d-flex justify-content-center pb-md-0">
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      branch.track("LoginWithGoogle")
                                    }
                                  >
                                    <button
                                      className="btn-google "
                                      onClick={SignInWithGoogle}
                                      style={{
                                        backgroundColor: "#262626",
                                        color: "white",
                                        fontWeight: "400",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      <img
                                        alt="main"
                                        src="/googleicon.svg"
                                        className={` fb ${
                                          i18n.language == "en"
                                            ? "me-md-2 me-2"
                                            : "ms-md-2 ms-2"
                                        }`}
                                      />
                                      Continue with Google
                                    </button>
                                  </div>
                                </div>
                                {/* sign in with apple */}
                                <div className="d-flex justify-content-center pb-md-0 mt-2 w-100">
                                  <div
                                    className="w-100"
                                    onClick={() =>
                                      branch.track("LoginWithApple")
                                    }
                                  >
                                    <button
                                      className="btn-google"
                                      onClick={SignInWithApple}
                                      style={{
                                        backgroundColor: "#262626",
                                        color: "white",
                                        fontWeight: "400",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      <img
                                        alt="main"
                                        src={applelogo}
                                        className={`fb ${
                                          i18n.language == "en"
                                            ? "me-md-2 me-2"
                                            : "ms-md-2 ms-2"
                                        }`}
                                      />
                                      Continue with Apple
                                    </button>
                                  </div>
                                </div>
                                {/* continue as guest */}
                                <div className=" text-center login-link px-0 mt-6   p-0  mx-0 ">
                                  <a
                                    data-dismiss="modal"
                                    className="login-link link"
                                    onClick={() =>
                                      handleSignIn(false) &
                                      handleContinueAsGuest() &
                                      dispatch(IsGuest(true))
                                    }
                                  >
                                    {t("Continue as a guest")}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}

                    {singupp && (
                      <div
                        style={{
                          // position: "absolute",
                          width: "100%",
                          opacity: singupp ? 1 : 0,
                          transition: "opacity 0.4s ease-in-out",
                          visibility: singupp ? "visible" : "hidden",
                        }}
                      >
                        <SignUp singupp={singupp} handleSignIn={handleSignIn} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SignIn;
